import React, { useEffect } from 'react';
import Light from '../assets/SVG/icons/light.png';
import NoGlasses from '../assets/SVG/icons/no-glass.png';
import CameraDistance from '../assets/SVG/icons/keep-distance-icon.png';
import '../styles/beforetest.css';
import Header from '../components/Header';

export default function BeforeTest(props) {
    function goToIntermediary() {
        props.history.push({
            pathname: '/intermediary',
            state: { isDemo: props?.location?.state?.isDemo }
        });
    }

    useEffect(() => {
        document.title = "Before you start";
    }, []);

    return (
        <div className="container">
            <div className="main beforetest">
                <Header/>
                <div className='heading mt-3'>
                    <p>Before you start:</p>
                </div>
                <div className='wrapper'>
                    <div className="info">
                        <img src={Light} alt="light"/> <p>Place your face in front of a direct white light.</p>
                    </div>
                    
                    <div className="info">
                        <img src={NoGlasses} alt="glasses and contact lenses"/> <p>Take off your glasses and clean off the camera lens.</p>
                    </div>
                    
                    <div className="info">
                        <img src={CameraDistance} alt="distance"/> <p>Keep the camera at eye level, and make sure you are close enough to see a green face contour.</p>
                    </div>
                </div>
                <div className='mb-5'>
                    <button id='continue' onClick={goToIntermediary}>I understand</button>
                </div>
            </div>
        </div>
    )
}
